import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import classes from './NestedLevel.module.css';
const BASE_LEVEL = 1;
export function NestedLevel({ level = BASE_LEVEL, lastChild = false, children, }) {
    if (level === BASE_LEVEL - 1) {
        return children;
    }
    return (_jsx("div", { className: clsx(classes.nestedLevel, lastChild && level === BASE_LEVEL && classes.nestedLevelLastChild), children: _jsx(NestedLevel, { level: level - 1, lastChild: lastChild, children: children }) }));
}
//# sourceMappingURL=NestedLevel.js.map